/**
 * Navigation shim — lets the ported components keep their v5-style
 * `history.push(url)` usage on top of React Router v7. A `<HistoryBridge>`
 * (rendered in App) registers the router's `navigate` here at runtime.
 */
type NavFn = (to: string, opts?: { replace?: boolean }) => void;

let navigator: NavFn | null = null;

export function setNavigator(fn: NavFn): void {
  navigator = fn;
}

function go(to: string, replace: boolean): void {
  if (navigator) navigator(to, { replace });
  else if (typeof window !== "undefined") window.location.assign(to);
}

const history = {
  push: (to: string) => go(to, false),
  replace: (to: string) => go(to, true),
};

export default history;
